var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('a',{attrs:{"target":"_blank","href":_vm.LINKS.logo.href,"title":_vm.LINKS.logo.title}},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/logo-bar-zum-schmutzigen-hobby.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }